import React from "react";
import { PatternFormat } from "react-number-format";
import Field from "./Field";

interface InputProps {
  label?: React.ReactNode;
  value?: string;
  name?: string;
  margin?: string;
  hint?: string;
  error?: string;
  required?: boolean;
  showIcon?: boolean;
  icon?: string;
  onChange?: (e: any) => void;
}

const Phone: React.FC<InputProps> = ({
  label = "Phone number",
  value,
  name,
  margin,
  hint,
  error,
  required,
  showIcon = true,
  icon = "bi-telephone",
  onChange,
  ...rest
}) => {
  return (
    <Field
      label={label}
      margin={margin}
      icon={showIcon ? icon : undefined}
      hint={hint}
      error={error}
      required={required}
    >
      <PatternFormat
        format="+1 (###) ###-####"
        placeholder="+1 (123) 456-7890"
        name={name}
        value={value}
        onValueChange={(values) => {
          onChange?.({
            target: {
              name: name,
              value: values.value,
            },
          });
        }}
        valueIsNumericString
        className="form-control"
        {...rest}
      />
    </Field>
  );
};

export default Phone;
